import { render } from "./mapPolygons.vue?vue&type=template&id=3d9eb962&scoped=true"
import script from "./mapPolygons.vue?vue&type=script&lang=js"
export * from "./mapPolygons.vue?vue&type=script&lang=js"

import "./mapPolygons.vue?vue&type=style&index=0&id=3d9eb962&lang=less&scoped=true"
/* custom blocks */
import block0 from "./mapPolygons.vue?vue&type=custom&index=0&blockType=doc"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d9eb962"]])

export default __exports__